import React from 'react'
import CustomersSayCard from './CustomersSayCard'
import './customerssay.css'

const CustomersSay = () => {
  return (
    <section className="customer-rating-section">
    <h2>Testimonials</h2>

    <CustomersSayCard />

    </section>
  )
}

export default CustomersSay